// @ts-strict-ignore
import { Dictionary } from 'typescript-collections';
import { ArticleVO } from '@article/model/vo/article.vo';
import { ArticleSearchResultVO } from '../model/vo/article-search-result.vo';
import { ArticleDataService } from '../service/article-data.service';
import { ArrayUtils } from '@shared/util/array-utils';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ArticleByTypeManager {

  private _articleTypeIdToArticleHead: Dictionary<number, ArticleVO> = new Dictionary<number, ArticleVO>();
  private _pendingArticleTypesForRetrieval: number[] = [];
  private _articlesRetrieved$ = new Subject<number>();

  constructor(private articleDataService: ArticleDataService) {}

  public get articlesRetrieved$(): Observable<number> {
    return this._articlesRetrieved$.asObservable();
  }

  public getArticleHeadByType(articleType: number): ArticleVO {
    if (!this.isArticleHeadByTypeExists(articleType)) {
      return null;
    }
    return this._articleTypeIdToArticleHead.getValue(articleType);
  }

  public retrieveArticleHeadByType(articleType: number): void {
    if (!this.isArticleHeadByTypeExists(articleType)) {
      if (!this.isPendingArticleType(articleType)) {
        this._pendingArticleTypesForRetrieval.push(articleType);
        this.articleDataService.findArticlesByType(articleType, 0, 1).subscribe(
          (articleSearchResult: ArticleSearchResultVO) => this.articlesByTypeLoaded(articleType, articleSearchResult),
          (error: any) => this.articlesByTypeLoaded_failure(articleType),
        );
      }
    } else {
      this.finalizeArticleRetrieval(articleType);
    }
  }

  public isArticleHeadByTypeExists(articleType: number): boolean {
    return this._articleTypeIdToArticleHead.containsKey(articleType);
  }

  public articlesByTypeLoaded(targetArticleType: number, articleSearchResult: ArticleSearchResultVO): void {
    if (isNaN(targetArticleType) || !this.isPendingArticleType(targetArticleType)) {
      return;
    }
    if (articleSearchResult && !ArrayUtils.isEmpty(articleSearchResult.articles)) {
      const articleHead: ArticleVO = articleSearchResult.articles[0];
      this._articleTypeIdToArticleHead.setValue(targetArticleType, articleHead);
    }
    this.finalizeArticleRetrieval(targetArticleType);
  }

  public articlesByTypeLoaded_failure(targetArticleType: number): void {
    if (isNaN(targetArticleType) || !this.isPendingArticleType(targetArticleType)) {
      return;
    }
    this.finalizeArticleRetrieval(targetArticleType);
  }

  private finalizeArticleRetrieval(articleType: number): void {
    if (isNaN(articleType)) {
      return;
    }
    const index: number = this._pendingArticleTypesForRetrieval.indexOf(articleType);
    if (index >= 0) {
      this._pendingArticleTypesForRetrieval.splice(index);
    }
    this._articlesRetrieved$.next(articleType)
  }

  private isPendingArticleType(articleType: number): boolean {
    return this._pendingArticleTypesForRetrieval.indexOf(articleType) >= 0;
  }
}
